export default __webpack_public_path__ + "static/media/GreenBanner.c417660c.png";